import React, {useState} from 'react';
import PickUpDateItemDrawer from "./PickUpDateItemDrawer";
import {useTranslation} from "react-i18next";
import PickUpDateMoreDaysDrawer from "./PickUpDateMoreDaysDrawer";
import {ReactComponent as EditIco} from "../../../../images/icons/edit.svg";

interface Props {
    title: string;
    icon: JSX.Element;
    elements: { value: string; label: string; disabled?: boolean }[];
    handleClickElement: (value: string) => void;
    currentValue: string;
    times?: boolean;
    handleClearDate?: () => Promise<void>;
    withoutAsSoonAsPossibleOption?: true;
    higherZIndex?: boolean;
}

const PickUpDateSectionDrawer = ({
                                     title,
                                     icon,
                                     elements,
                                     handleClickElement,
                                     currentValue,
                                     times,
                                     handleClearDate,
                                     withoutAsSoonAsPossibleOption,
                                     higherZIndex
                                 }: Props) => {
    const valueToDisplay = elements.find(({value}) => value === currentValue)?.label;
    const {t} = useTranslation();
    const MAX_ELEMENTS_TO_DISPLAY = 9;
    const filteredElements = times ? elements : elements.filter((_, index) => index < MAX_ELEMENTS_TO_DISPLAY);
    const [showMoreDaysDrawer, setShowMoreDaysDrawer] = useState(false);

    const isAnotherDaySelected = () => {
        return currentValue && !filteredElements.find(({value}) => value === currentValue)
    }

    const getAnotherDayButtonTitle = () => {
        let result = t("modules.date_modal.field.another_day.title");

        if (isAnotherDaySelected()) {
            const valueToDisplay = elements.find(({value}) => value === currentValue)?.label;
            result += ` (${valueToDisplay})`
        }

        return result;
    };

    const getMoreElement = () => {
        return elements.filter((_, index) => index >= MAX_ELEMENTS_TO_DISPLAY);
    }

    return (
        <>
            <div className="d-flex flex-column pick-up-date-drawer-section">
                <div className="d-flex align-items-center gap-2 mb-3">
                    {icon}
                    <h5 className="mb-0">{title}</h5>
                    {valueToDisplay && <p className="mb-0 selected-value">{valueToDisplay}</p>}
                </div>
                {handleClearDate && withoutAsSoonAsPossibleOption !== true && <button className="btn btn-default"
                                                                                      onClick={handleClearDate}>{t("common.word.as_soon_as_possible")}</button>}
                <div
                    className={`elements mt-2 ${times ? "times" : ""} ${filteredElements.length === 1 ? "single-element" : ""}`}>
                    {filteredElements.map(element => (
                        <PickUpDateItemDrawer title={element.label} key={element.value}
                                              onClick={() => handleClickElement(element.value)}
                                              active={currentValue === element.value} disabled={element.disabled}/>
                    ))}
                </div>
                {!times && getMoreElement().length > 0 &&
                    <button className={`btn btn-default ${isAnotherDaySelected() ? "selected" : ""} mt-2`}
                            onClick={() => setShowMoreDaysDrawer(true)}>
                        {getAnotherDayButtonTitle()}
                        <EditIco className="ms-2"/>
                    </button>}
            </div>
            {showMoreDaysDrawer && <PickUpDateMoreDaysDrawer show={showMoreDaysDrawer}
                                                             onHide={() => setShowMoreDaysDrawer(false)}
                                                             days={getMoreElement()}
                                                             date={currentValue}
                                                             higherZIndex={higherZIndex}
                                                             handleChangeDate={handleClickElement}
            />}
        </>
    )
}

export default PickUpDateSectionDrawer;